/* src/app/components/filter-cpo-selector/filter-cpo-selector.component.scss */
.cpo-options-shell {
  position: relative;
}
.cpo-options-shell::before,
.cpo-options-shell::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  height: 10px;
  pointer-events: none;
  z-index: 1;
}
.cpo-options-shell::before {
  top: 0;
  background:
    linear-gradient(
      180deg,
      var(--ion-card-background, #fff),
      rgba(255, 255, 255, 0));
}
.cpo-options-shell::after {
  bottom: 0;
  background:
    linear-gradient(
      0deg,
      var(--ion-card-background, #fff),
      rgba(255, 255, 255, 0));
}
.cpo-options-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px 12px;
  max-height: 154px;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 2px 0 0;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding-top: 8px;
}
.cpo-options-grid::-webkit-scrollbar {
  display: none;
}
.cpo-button {
  appearance: none;
  border: 0;
  background: transparent;
  color: var(--ion-color-dark, #0b2f48);
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 6px;
  height: 56px;
  width: 100%;
  padding: 0;
  margin: 0;
  opacity: 0.48;
  transition: opacity 120ms ease, transform 120ms ease;
}
.cpo-button:active {
  transform: scale(0.96);
}
.cpo-button ion-icon {
  font-size: 28px;
  max-width: 34px;
  max-height: 28px;
}
.cpo-button--selected {
  opacity: 1;
}
.cpo-button--selected .cpo-icon-frame {
  background: transparent;
  box-shadow: none;
}
.cpo-icon-frame {
  align-items: center;
  background: transparent;
  border-radius: 0;
  display: flex;
  height: 28px;
  justify-content: center;
  transition: background 120ms ease, box-shadow 120ms ease;
  width: 34px;
}
.cpo-image {
  max-width: 34px;
  max-height: 28px;
  object-fit: contain;
}
.cpo-label {
  color: currentColor;
  display: block;
  font-size: 11px;
  font-weight: 600;
  line-height: 13px;
  max-width: 100%;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/*# sourceMappingURL=filter-cpo-selector.component.css.map */
